import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AdsGETApiAuth, AdsPUTApi, AdsPUTApiToken, ImageURL, signInImage, UserMeEdit } from '../../Constant/api';
import { slugs } from '../../Constant/slugs';
import { login, logout } from '../../redux/action';
import store from '../../redux/store';
import ImageUpload from '../ImageUpload';
import SideBar from '../SideBar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import './profile.css'
export default function Profile() {
  const Login = useSelector((state) => state.LoginState);
  const dispatch = useDispatch()
  const [ID, setID] = React.useState("")
  const [UserID, setUserID] = React.useState("")
  const [Name, setName] = React.useState("")
  const [Photo, setPhoto] = React.useState("")
  const [PhoneNumber, setPhoneNumber] = React.useState("")
  const [Email, setEmail] = React.useState("")
  const [user, setUser] = React.useState({})
  const [userDetails, setUserDetails] = React.useState({})
  const [usersDataID, setusersDataID] = React.useState("")
  const [UserFetch, setUserFetch] = React.useState(false)
  const [BatchStatus, setBatchStatus] = React.useState("")
  const [SubscriptionPressed, setSubscriptionPressed] = React.useState(false)
  const [PaymentMethod, setPaymentMethod] = React.useState("")
  const [ScreenShotUrl, setScreenShotUrl] = React.useState("")
  const [SubscriptionVerifyDone, setSubscriptionVerifyDone] = React.useState(false)
  const [reload, setReload] = React.useState(false)
  const [BankImageSelect, setBankImageSelect] = React.useState(false)
  const [BankImageUrl, setBankImageUrl] = React.useState("")

  const LoginState = useSelector((state) => state.LoginState);
  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")
  const [editProfileModal, setEditProfileModal] = React.useState(false)
  const [changePasswordModal, setChangePasswordModal] = React.useState(false)
  const [oldPassword, setOldPassword] = React.useState("")
  const [newPassword, setNewPassword] = React.useState("")
  const [newConfirmPassword, setNewConfirmPassword] = React.useState("")
  const [batchName, setBatchName] = React.useState("")
  const [batchModal, setBatchModal] = React.useState(false)
  const [batchID, setBatchID] = React.useState("")
  const [UBTC, setUBTC] = React.useState(true)
  const [passwordError, setpasswordError] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)
  const history = useHistory()

  const UserDetails = () => {
    setUserFetch(false)
    setReload(true)
    const id = Login.userID
    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": id,
      "filter[meta_query][1][compare]": "=",
      _fields: "id,title,meta,slug,id"
    }, "user_data")
      .then((response) => {
        if (response.data.length !== 0) {
          setUserDetails(response.data[0])
          setEmail(response.data[0].meta.user_email)
          setUserFetch(true)
          setUser(response.data[0])
          setUserID(response.data[0].meta.user_id)
          setusersDataID(response.data[0].id)
          setID(response.data[0].id)
          // if (response.data[0].meta.batch_id !== "")
          //   AdsGETApiAuth({ _fields: "id,meta.batch_status" }, `${slugs.db_slug_batch}/${response.data[0].meta.batch_id}`)
          //     .then(res => {
          //       setBatchStatus(res.data.meta.batch_status)
          //     })

          if (response.data[0].meta.user_role == "teacher") {
            ExamList()
            setBatchName(response.data[0].meta.user_featured_exam_slug)
            setBatchID(response.data[0].meta.user_featured_exam_slug)
            setID(response.data[0].id)
          }
          if (response.data[0].meta.batch_id == Login.userBatch)
            console.log("same")
          else {
            dispatch(login(
              `${Login.userID}`,
              `${Login.userName}`,
              `${Login.token}`,
              `${Login.userEmail}`,
              `${response.data[0].meta.user_role}`,
              `${response.data[0].meta.user_profile_picture}`,
              `${response.data[0].meta.user_phone_number}`,
              `${response.data[0].meta.batch_id}`,
            ))
          }
        }
        else {
          dispatch(logout())
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setReload(false)
      })
  }
  const EditUser = () => {
    setReload(true)
    AdsPUTApi({
      email: Email
    }, "users", UserID)
      .then(res2 => {
        AdsPUTApi(
          {
            meta: {
              user_email: Email,
            }
          },
          "user_data", ID
        ).then(res => {
          setReload(false)
        }).catch(() => {

        })
      })
      .catch(err => {
        setAlertShow(true)
        setReload(false)
        setAlertcomp("Email Already Registered")
      })

  }
  const UserDetailsSubscriptionEdit = () => {
    setReload(true)
    const date = new Date();
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    const data2 = {}

    console.log(usersDataID)
    AdsPUTApi(data2, "users_data", usersDataID)
      .then((res) => {
        setReload(false)
        setSubscriptionVerifyDone(true)
        console.log(res.data)
      }).catch((err) => {
        console.warn(err);
        console.warn(err.response.data);
      })
  }
  useEffect(() => {
    UserDetails()

  }, [])
  const [serachName, setSearchName] = React.useState("")
  const [ExamArray, setExamArray] = React.useState([])
  const [ExamArray1, setExamArray1] = React.useState([])

  const ExamList = () => {
    AdsGETApiAuth(
      { per_page: 1000, _fields: "id,slug,title,meta.exam_type" },
      slugs.db_slug_paid_exam
    )
      .then((res) => {
        setExamArray1(res.data)
        setExamArray(res.data.filter(a => a.meta.exam_type == "UBT"))
        // setExamSelect(res.data)
      })
      .catch(e => {
        console.log(e)
      })
  }
  const AlertComponent = () => {
    return (
      <div className="modal"
        onClick={() => {
          setAlertShow(false)
        }}
      >
        <div>
          <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
            <div className="col-lg-4 col-1"></div>
            <div className="col-lg-4 col-10 pb-5  bg-white  shadow">
              <div className="p-5">
                <div dangerouslySetInnerHTML={{ __html: Alertcomp }}></div>
              </div>
              <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                <div className="sign-in-button-1 col-8">
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className="row">
        <div className="col-2">
        </div>
        <>
          {/* {UserFetch &&
          <section className="col-8 form-view mt-3">
            <center style={{ margin: "10px" }}>
              {userDetails.meta.user_profile_picture !== "" ?
                <img src={userDetails.meta.user_profile_picture}
                  style={{ width: "100px", height: "100px", borderRadius: "100px", border: "1px solid black" }}
                />
                :
                <div className="center"
                  style={{ fontSize: "70px", width: "100px", height: "100px", borderRadius: "100px", border: "1px solid black" }}
                >
                  <i className="fa fa-user"
                  />
                </div>
              }
            </center>
            <span style={{ cursor: "pointer" }}>
              <center>
                Logout
                <i className="fa fa-sign-out" style={{ fontSize: "20px" }}
                  onClick={() => {
                    history.push('/')
                    dispatch(logout())
                  }}
                />
              </center>
            </span>
            <div className="col-10">
              <table>
                <tbody>
                  <tr>
                    <td>User Name</td>
                    <td>{userDetails.meta.user_name}</td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>{userDetails.meta.user_phone_number}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{userDetails.meta.user_email}</td>
                  </tr>
                  <tr>
                    <td>Verification Status</td>
                    <td>{userDetails.meta.verification_status}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        } */}
        </>
        {UserFetch && (
          <main className="profile-page">
            <section className="profile-card">
              <div className="profile-header">
                <div className="profile-avatar">
                  {/* {userDetails.meta.user_profile_picture ? ( */}
                  <img
                    src={signInImage}
                    alt={userDetails.meta.user_name || "User profile"}
                  />
                  {/* ) : (
                    <i className="fa fa-user" aria-hidden="true" />
                  )} */}
                </div>

                <h1 className="profile-name">
                  {userDetails.meta.user_name}
                </h1>

                <button
                  type="button"
                  className="profile-logout-button"
                  onClick={() => {
                    history.push("/");
                    dispatch(logout());
                  }}
                >
                  <span>Logout</span>
                  <i className="fa fa-sign-out" aria-hidden="true" />
                </button>
                <div style={{ margin: "10px" }}>
                  <button
                    type="button"
                    className="profile-reset-pw-button"
                    onClick={() => {
                      setChangePasswordModal(true)
                    }}
                  >
                    <span>Change Password</span>
                    <i className="fa fa-sign-out" aria-hidden="true" />
                  </button>
                </div>
                <div style={{ margin: "10px" }}>
                  <button
                    type="button"
                    className="profile-reset-pw-button"
                    onClick={() => {
                      setEditProfileModal(true)
                    }}
                  >
                    <span>Change Email</span>
                    <i className="fa fa-sign-out" aria-hidden="true" />
                  </button>
                </div>
              </div>

              <div className="profile-details">
                <div className="profile-detail-row">
                  <span className="profile-detail-label">
                    User Name
                  </span>

                  <span className="profile-detail-value">
                    {userDetails.meta.user_name || "—"}
                  </span>
                </div>

                <div className="profile-detail-row">
                  <span className="profile-detail-label">
                    Phone Number
                  </span>

                  <span className="profile-detail-value">
                    {userDetails.meta.user_phone_number || "—"}
                  </span>
                </div>

                <div className="profile-detail-row">
                  <span className="profile-detail-label">
                    Email

                  </span>

                  <span className="profile-detail-value profile-email">
                    {userDetails.meta.user_email || "—"}
                  </span>
                </div>

                {/* <div className="profile-detail-row">
                  <span className="profile-detail-label">
                    Verification Status
                  </span>

                  <span
                    className={`profile-status ${userDetails.meta.verification_status
                        ?.toLowerCase()
                        .includes("verified")
                        ? "verified"
                        : "pending"
                      }`}
                  >
                    {userDetails.meta.verification_status || "Pending"}
                  </span>
                </div> */}
              </div>
            </section>
          </main>
        )}
      </div>
      {changePasswordModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10">
              <div
              // style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}
              >
                <section className="change-password-card">
                  <h2 className="change-password-title">
                    Change Password
                  </h2>

                  <div className="password-grid">

                    <div className="password-group">
                      <label>Current Password</label>
                      <input
                        type={!showPassword ? "password" : "text"}
                        value={oldPassword}
                        placeholder="Enter current password"
                        onChange={(e) => {
                          setOldPassword(e.target.value)
                          setpasswordError(false)
                        }}
                      />
                    </div>

                    <div className="password-group">
                      <label>New Password</label>
                      <input
                        type={!showPassword ? "password" : "text"}
                        value={newPassword}
                        placeholder="Enter new password"
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>

                    <div className="password-group">
                      <label>Confirm Password</label>
                      <input
                        type={!showPassword ? "password" : "text"}
                        value={newConfirmPassword}
                        placeholder="Confirm new password"
                        onChange={(e) =>
                          setNewConfirmPassword(e.target.value)
                        }
                      />
                    </div>

                  </div>
                  <div className="row">
                    <div className="row " style={{ cursor: 'pointer', width: "100%" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <div className="showPassword" style={{ width: "10%", }}>
                        {!showPassword ?
                          <i className="fa fa-square-o" />
                          :
                          <i className="fa fa-check-square-o" />
                        }
                      </div>
                      <div className="showPassword" style={{ width: "80%" }}>Show password</div>
                    </div>
                  </div>
                  {passwordError &&
                    <p className="otp-error" style={{ fontSize: "10px" }}>
                      The old password is incorrect. Please try again.
                    </p>
                  }

                  <div className="password-buttons">

                    <button
                      className="update-password-btn"
                      onClick={() => {
                        /* Your existing password update code */
                        setUserFetch(false)
                        setReload(true)
                        const id = Login.userID
                        const dataWithPassword = {
                          "password": newConfirmPassword,
                        }
                        AdsPUTApiToken(dataWithPassword, `users`, `${id}`, `${window.btoa(`${userDetails.meta.user_name}:${oldPassword}`)}`)
                          .then(res => {
                            dispatch(login(
                              `${id}`,
                              `${userDetails.meta.user_name}`,
                              `${window.btoa(`${userDetails.meta.user_name}:${newConfirmPassword}`)}`,
                              `${userDetails.meta.user_email}`,
                              `${userDetails.meta.user_role}`,
                              ``,
                              `${PhoneNumber}`,
                              ``,
                            ))
                            AdsPUTApiToken({
                              meta: {
                                "class_code": newConfirmPassword,
                              }
                            }, slugs.db_slug_user_data, ID, `${window.btoa(`${userDetails.meta.user_name}:${newPassword}`)}`)
                              .then(res =>
                                console.log(res)
                              )
                            setReload(false)
                            setUserFetch(true)
                            setChangePasswordModal(false)
                            setAlertcomp("Password Changed Successfully")
                            setAlertShow(true)
                            setOldPassword("")
                            setNewConfirmPassword("")
                            setNewPassword("")
                          })
                          .catch(e => {
                            console.log(e)
                            setpasswordError(true)
                            // setAlertcomp("Old Password didnot match. Please Contact Admin")
                            // setAlertShow(true)
                            setReload(false)
                            setUserFetch(true)
                            // setChangePasswordModal(false)
                            // if (e.message.includes("Request failed with status code 500"))
                            //   dispatch(logout())
                          })
                      }}
                    >
                      Update Password
                    </button>

                    <button
                      className="cancel-password-btn"
                      onClick={() => {
                        setOldPassword("");
                        setNewPassword("");
                        setNewConfirmPassword("");
                        setChangePasswordModal(false)
                      }}
                    >
                      Cancel
                    </button>

                  </div>
                </section>


              </div>
            </div>
          </div>
        </section >
      }


      {
        editProfileModal &&
        <section className="modal" style={{ padding: "10vh" }}>
          <div className="row">
            <div className="col-lg-3">

            </div>
            <div className="col-lg-6" style={{ backgroundColor: "#fff", padding: "30px" }}>
              {/* <div style={{ textAlign: 'right', fontSize: 22, padding: 10, cursor: 'pointer' }}
                onClick={() => {
                  setEditProfileModal(false)
                }}
              >
                <i className="fa fa-close" />
              </div>
              Edit Profile Picture
              <ImageUpload
                ImageUrl={Photo}
                setImageUrl={setPhoto}
              /> */}
              <div>
                <div style={{ margin: "10px 0 3px" }}><b>Edit Email</b></div>
                <div className="row" >
                  <input className="my-2 p-2 px-2 col-11" style={{ margin: "30px" }}
                    type="email"
                    value={Email}
                    onChange={(event) => {
                      setEmail(event.target.value)
                    }}
                    placeholder="Edit Email"
                    required
                  />
                </div>
              </div>
              <div className="password-buttons center">
                <button
                  className="cancel-password-btn"
                  onClick={() => {
                    setEditProfileModal(false)

                  }}
                >
                  Cancel
                </button>
                <button
                  className="update-password-btn"
                  onClick={() => {
                    EditUser()
                    setEditProfileModal(false)
                  }}
                >
                  Update Profile
                </button>

              </div>
            </div>
            <div className="col-lg-3">

            </div>
          </div>
        </section>

      }

      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent />
      }
    </div >
  )
}